export enum TokenType {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY",
}
